import { TuiInput } from '@taiga-ui/core';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { LocaleFlagPipe } from '@locale/pipes/locale-flag.pipe';
import { Locale } from '@pixacare/domain';
import { AppConfigHttpService } from '@services/http/app-config.http.service';
import { CapitalizePipe } from '@shared/pipes/capitalize.pipe';
import { TuiChevron, TuiDataListWrapper, TuiFlagPipe, TuiSelect } from '@taiga-ui/kit';

type OnChangeFn = (value: string) => void;

@Component({
  selector: 'pxc-telemonitoring-locale-picker',
  imports: [
    TuiFlagPipe,
    TuiDataListWrapper,
    FormsModule,
    ReactiveFormsModule,
    TuiChevron,
    TuiInput,
    LocaleFlagPipe,
    TranslocoDirective,
    TuiSelect,
    CapitalizePipe,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: TelemonitoringLocalePickerComponent,
    },
  ],
  templateUrl: './telemonitoring-locale-picker.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TelemonitoringLocalePickerComponent implements ControlValueAccessor {
  private readonly appConfigHttpService = inject(AppConfigHttpService);
  private readonly translocoService = inject(TranslocoService);

  @Input() placeholder = this.translocoService.translate('Sélectionnez la langue du patient');

  disabled = false;
  touched = false;
  value: string;
  selectedLocale: Locale | null = null;

  get locales(): Locale[] {
    return this.appConfigHttpService.configuration.supportedLocales;
  }

  onChange: OnChangeFn = () => {};
  onTouched: () => void = () => {};

  writeValue(locale: string): void {
    this.value = locale;
    this.selectedLocale = this.locales.find((l) => l.code === locale) || null;
  }

  registerOnChange(fn: OnChangeFn): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onSelectChange(locale: Locale): void {
    this.touched = true;
    this.value = locale.code;
    this.selectedLocale = locale;
    this.onChange(locale.code);
  }
}
